import React from "react";

export const SectionInfo = ({
  leftComponent,
  rightComponent,
  reverse = false,
  alignContentRightItem,
  alignContentLeftItem,
}: {
  leftComponent: JSX.Element;
  rightComponent?: JSX.Element;
  reverse?: boolean;
  alignContentRightItem?: string;
  alignContentLeftItem?: string;
}) => {
  return (
    <div
      className={
        reverse
          ? "row row-cols-1 row-cols-md-2 flex-row-reverse align-items-center my-4 pt-sm-4"
          : "row row-cols-1 row-cols-md-2 align-items-center my-4 pt-sm-4"
      }
    >
      <div className={`col ${alignContentLeftItem}`}>{leftComponent}</div>
      <div className={`col ${alignContentRightItem}`}>{rightComponent}</div>
    </div>
  );
};
